import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import help from "../assets/js/help";
export default {
  name: "ServeModal",
  components: {},
  props: {
    item: {
      type: Object,
      default: function _default() {
        return {
          addr: ""
        };
      }
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      tip: "> 点击复制微信号 <"
    };
  },
  computed: {
    titleInfo: function titleInfo() {
      if (this.title) {
        return this.title;
      } else {
        return "收货信息:";
      }
    }
  },
  methods: {
    onClickCopy: function onClickCopy(text) {
      help.copyText2(text);

      _Toast("复制成功");
    },
    onClickClose: function onClickClose() {
      console.log(1);
      this.$emit("update:show", false);
    }
  }
};